import { ModelBase } from 'store/model-base';
import { PlanCardsType } from 'core/constants';
import { PromoType } from 'my-account/constants';
export class targetPlanSwitchDetails extends ModelBase {
    public static storeName: string = 'targetPlanSwitchDetails';
    public lineId?: string;
    public selectionPage!: SelectionPageDetails;
    public xmcSelectionPage: XMCSelectionPageDetails;
    public scheduledTargetPlan?: PlanCardsDetails;
    public allPromoContent: PromotionContent[];

    public static create<T extends ModelBase>(initData: object = {}): T {
        const toReturn: targetPlanSwitchDetails = super.create<targetPlanSwitchDetails>(initData);
        toReturn.scheduledTargetPlan = toReturn.selectionPage?.planCards?.find((planCard: PlanCardsDetails) => planCard.badge.toLowerCase() === PlanCardsType.SCHEDULED);
        toReturn.allPromoContent = toReturn.allPromotionContentArray();

        return <T><unknown>toReturn;
    }

    public allPromotionContentArray(): PromotionContent[] {
        const promotionStart: { [key: string]: PromotionContent[] } = this.selectionPage?.promotionStart;
        if (!promotionStart) return [];

        const allPromotions: PromotionContent[] = [PromoType.LOSS, PromoType.KEEP, PromoType.ELIGIBLE].flatMap((key: string) => promotionStart[key] || []);
        // Then sort them with notifications first

        return allPromotions.sort((a: PromotionContent, b: PromotionContent) => {
            if (a.type === 'notification' && b.type !== 'notification') {
                return -1; // a comes before b
            } else if (a.type !== 'notification' && b.type === 'notification') {
                return 1; // b comes before a
            }

            return 0; // keep original order for other types
        });
    }
}
